import { EntityService } from './EntityService';
import { IRiskRiskType } from '../types/RiskRiskType';

export class RiskRiskTypeService extends EntityService<IRiskRiskType> {
    constructor() {
        super(`/RiskRiskTypes`);
    }
}